import {FC, PropsWithChildren} from 'react'
import './ProcurementActionGrid.css'

const ProcurementActionGrid: FC<PropsWithChildren> = ({children}) => (
  <div className='procurement-action-grid'>{children}</div>
)

export default ProcurementActionGrid
